import React from 'react'
import { Button, Dropdown, Form, Input, Spin, Tree } from 'antd'

import i18n from 'i18n'
// import 'react-perfect-scrollbar-z/build/styles.css'
// import PerfectScrollbar from 'react-perfect-scrollbar-z'

// import PerfectScrollbar from 'libs/react-perfect-scrollbar'

import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import { compareStr } from 'utils'
import { getInitialAvatarSrc } from 'utils/ui'

import rightIcon from '@/assets/images/chevron-right-24.svg'
import downIcon from '@/assets/images/chevron-down-24.svg'
import toolbarMore24 from '@/assets/images/toolbar-more-24.svg'
import search24SVG from '@/assets/images/toolbar-search-24.svg'
import iconClear20SVG from '@/assets/images/icon-clear-20.svg'

import helper from './helper'

import styles from './style.module.scss'

const { Search } = Input

class OrgChartUserListDef extends React.Component {
  state = {
    loading: false,
    checkedKeys: [],
    expandedKeys: [],
    treeInfo: null,
    treeHeight: 0,
    isMobile1: window.innerWidth <= 768,
  }

  formRef = React.createRef()

  // scrollRef = React.createRef()

  treeRef = React.createRef()

  treeInfo = {}

  checkedKeys = []

  expandedKeys = []

  userKeyMap = {}

  searchText = null

  isFirst = true

  async componentDidMount() {
    helper.changeListener.add(this.listChanged)

    this.reload()

    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    helper.changeListener.remove(this.listChanged)
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ isMobile1: window.innerWidth <= 768 })
  }

  createObserver = () => {
    if (this.observerObj == null) {
      this.observerObj = {}

      this.observerObj.calcHeight = () => {
        if (this.observerObj.resizeTimer != null) {
          cancelAnimationFrame(this.observerObj.resizeTimer)
        }
        this.observerObj.resizeTimer = requestAnimationFrame(() => {
          if (this.observerObj.element != null) {
            const { offsetHeight } = this.observerObj.element
            if (this.observerObj.prevHeight !== offsetHeight) {
              this.observerObj.prevHeight = offsetHeight
              this.setState({
                treeHeight: offsetHeight,
              })
              this.observerObj.resizeTimer = null
            }
          }
        })
      }

      this.observerObj.observer = new ResizeObserver((e) => {
        console.log(' resize flowarea - ', e)
        this.observerObj.calcHeight()
      })

      this.observerObj.clear = () => {
        const { observer, element, resizeTimer } = this.observerObj
        if (observer != null && element != null) {
          observer.disconnect()
          if (resizeTimer != null) {
            cancelAnimationFrame(resizeTimer)
          }
        }
      }
    }
  }

  setRef = (ref) => {
    if (ref != null) {
      this.createObserver()

      if (this.observerObj.ref !== ref || this.observerObj.element !== ref) {
        this.observerObj.clear()

        this.observerObj.element = ref
        this.observerObj.ref = ref

        if (this.observerObj.element != null) {
          this.observerObj.calcHeight()
          this.observerObj.observer.observe(this.observerObj.element, { box: 'border-box' })
        }
      }
    }
  }

  getDepartmentKey = (departmentId) => {
    return `dep_${departmentId}`
  }

  getUserKey = (userId) => {
    return `user_${userId}`
  }

  getUniqueUserKey = (userId, ext) => {
    return `user_${userId}_ext_${ext}`
  }

  getUserKeyByUniqueKey = (uniqueKey) => {
    const pos = uniqueKey.indexOf('_ext_')
    const str = uniqueKey.substring(0, pos)
    return str
  }

  getUserIdByKey = (uniqueKey) => {
    const pos = uniqueKey.indexOf('_ext_')
    const str = uniqueKey.substring(5, pos)
    return parseInt(str, 10)
  }

  // 조직도 노드에서 officenext_user_id 안전 추출 + str 변환 (매칭 키 단일화).
  // user 객체는 { data: { id, account, ... } } 구조(listChanged/titleRender가 .data 사용).
  getOfficenextUserId = (nodeData) => {
    if (nodeData == null) return null
    const id = nodeData.data != null ? nodeData.data.id : nodeData.id
    return id != null ? String(id) : null
  }

  // KR 라이센스 미보유(비활성) 판정 — enforce ON + active 집합에 없음.
  isLicenseInactive = (nodeData) => {
    const { licenseEnforce, activeLicenseSet } = this.props
    if (licenseEnforce !== true || activeLicenseSet == null) return false
    const oid = this.getOfficenextUserId(nodeData)
    return oid != null && !activeLicenseSet.has(oid)
  }

  listChanged = (originalData) => {
    const { excludeEmailList, defaultEmailList } = this.props

    // const originalData = JSON.parse(getOrgChartData());
    // const originalData = getOrgChartData();
    // originalData.users = originalData.users.map((user) => {
    //   return { id: user.id, data: user };
    // });

    const userList = []
    originalData.users.forEach((user) => {
      const { id, account } = user.data
      if (excludeEmailList == null || excludeEmailList.indexOf(account) < 0) {
        const userKey = this.getUserKey(id)
        if (this.userKeyMap[userKey] == null) {
          this.userKeyMap[userKey] = user
        }
        userList.push(user)
      }
    })

    const orgChartData = {
      departments: originalData.departments,
      users: userList,
    }

    this.orgChartData = orgChartData

    const treeInfo = this.getTreeData()

    const newState = {
      loading: false,
      treeInfo,
    }

    // if (this.isFirst === true && orgChartData.users.length < 100) {
    if (this.isFirst === true) {
      this.isFirst = false
      this.expandedKeys = orgChartData.departments?.map((dep) => {
        return this.getDepartmentKey(dep.id)
      })
      this.expandedKeys?.push(this.getDepartmentKey('etc'))
      newState.expandedKeys = Array.isArray(this.expandedKeys) ? [...this.expandedKeys] : []

      this.checkedKeys = []
      const { orgUserMap } = this.treeInfo
      userList.forEach((user) => {
        const { id, account } = user.data
        if (defaultEmailList != null && defaultEmailList.indexOf(account) > -1) {
          if (orgUserMap[id] != null) {
            orgUserMap[id].forEach((node) => {
              this.checkedKeys.push(node.key)
            })
          }
        }
      })

      newState.checkedKeys = [...this.checkedKeys]
    }

    this.setState(newState)
  }

  reload = () => {
    this.treeInfo = {}

    this.setState({ loading: true })
    helper.startLoading()
  }

  notifyChecked = (checkedKeys) => {
    console.log('notifyChecked - ', checkedKeys)

    this.checkedKeys = Array.from(new Set([...(this.checkedKeys || []), ...checkedKeys]))

    const { onSelectChanged } = this.props

    const checkedEmails = []
    const checkedUsers = []
    checkedKeys
      .filter((key) => {
        return key.indexOf('user_') === 0
      })
      .forEach((key) => {
        const userKey = this.getUserKeyByUniqueKey(key)
        const user = this.userKeyMap[userKey]
        if (user != null && checkedEmails.indexOf(user.data.account) < 0) {
          checkedEmails.push(user.data.account)
          checkedUsers.push(user.data)
        }
      })

    if (onSelectChanged != null) {
      onSelectChanged(checkedEmails, checkedUsers)
    }
  }

  onItemClick = (userData) => {
    const { onSelectedChange } = this.props

    if (onSelectedChange != null) {
      onSelectedChange(userData.data)
    }
  }

  onMenuClick = (type, key) => {
    if (type === 'more') {
      if (key === 'refresh') {
        this.reload()
      }
    }
  }

  onSearch = (value) => {
    console.log('onSearch - ', value)
    if (value != null && value.length > 0) {
      this.searchText = value
    } else {
      this.searchText = null
    }

    const treeInfo = this.getTreeData()

    // if (this.searchText == null) {
    //   this.expandedKeys = []
    // } else {
    this.expandedKeys = this.orgChartData.departments.map((dep) => {
      return this.getDepartmentKey(dep.id)
    })
    this.expandedKeys.push(this.getDepartmentKey('etc'))
    // }

    const newState = {
      treeInfo,
      expandedKeys: [...this.expandedKeys],
    }

    this.setState(newState)

    // if (this.scrollRef.current != null) {
    //   this.scrollRef.current.element.scrollTop = 0
    //   this.scrollRef.current.update()
    // }

    const { treeData } = treeInfo
    if (treeData != null && treeData.length > 0) {
      const { key } = treeData[0]

      if (this.treeRef.current != null) {
        this.treeRef.current.scrollTo({ key, align: 'top' })
      }
    }
  }

  onChange = (e) => {
    console.log('onChange - ', e)
    const { value } = e.target
    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer)
    }

    this.searchTimer = setTimeout(() => {
      this.searchTimer = null

      this.onSearch(value)
    }, 500)
  }

  getTreeData = () => {
    // console.log(' --- orgChartData --- ', orgChartData);
    const { departments, users, jobpositions, jobtitles } = this.orgChartData
    const { searchText } = this

    this.treeInfo = {
      orgNodeMap: {},
      orgUserMap: {},
      jobUserMap: {},
      etcNode: {
        key: this.getDepartmentKey('etc'),
        children: [],
        count: 0,
        type: 0,
        originData: {
          name: i18n.t('workspace.orgChart.unspecified'),
        },
        isLeaf: false,
      },
    }

    const filteredUniqueKeyMap = {}

    let sText = null
    if (searchText != null && searchText.length > 0) {
      sText = searchText.toLowerCase()
    }

    // 부서 이름 검색 시 하위 부서 멤버까지 포함되도록,
    // 자기 자신 또는 상위 부서 이름이 검색어와 일치하는 부서 id 집합을 미리 계산한다.
    let matchedDeptIdSet = null
    // '미소속'(etc) 노드는 departments 에 없는 합성 노드라 위 집합으로 커버되지 않는다 —
    // 라벨(i18n) 매칭 여부와 "부서 소속 여부" 판별용 집합을 별도로 계산한다.
    let matchesEtcLabel = false
    let deptMemberIdSet = null
    if (sText != null) {
      const deptMap = {}
      departments?.forEach((department) => {
        deptMap[department.id] = department
      })

      matchedDeptIdSet = new Set()
      departments?.forEach((department) => {
        let current = department
        const visited = new Set()
        while (current != null && visited.has(current.id) === false) {
          visited.add(current.id)
          const currentName = current.name != null ? current.name.toLowerCase() : ''
          if (currentName.indexOf(sText) >= 0) {
            matchedDeptIdSet.add(department.id)
            break
          }
          current = current.parent_id != null ? deptMap[current.parent_id] : null
        }
      })

      const etcName = this.treeInfo.etcNode.originData.name
      matchesEtcLabel = etcName != null && etcName.toLowerCase().indexOf(sText) >= 0

      // id 는 String 으로 정규화해 담는다 — members[].user_id 와 users[].data.id 는
      // officenext 원본이라 한쪽이 문자열/숫자로 어긋날 수 있고, Set 은 strict 비교라
      // 정규화 없이는 부서 소속 멤버가 전부 미소속으로 오분류된다 (파일 내 다른 매칭은
      // getUserKey 의 `user_${id}` 템플릿 키로 이미 타입을 흡수하고 있음).
      deptMemberIdSet = new Set()
      departments?.forEach((department) => {
        department.members?.forEach((member) => {
          deptMemberIdSet.add(String(member.user_id))
        })
      })
    }

    const filteredUsers = users.filter((user) => {
      if (sText != null) {
        // '미소속' 라벨 검색 시: 어느 부서에도 속하지 않은 사용자는 이름 불일치여도 포함.
        // orgUserMap 빈 것으로 미소속을 추론하면 "부서 소속이지만 필터로 걸러진 멤버"가
        // 미소속으로 새므로, 반드시 부서 members 기준 집합으로 판별한다.
        if (matchesEtcLabel === true && deptMemberIdSet.has(String(user.data.id)) === false) {
          return true
        }
        const { account, display_name: displayName } = user.data
        const email = account != null ? account.toLowerCase() : ''
        const name = displayName != null ? displayName.toLowerCase() : ''
        if (email.indexOf(sText) < 0 && name.indexOf(sText) < 0) {
          return false
        }
      }
      return true
    })

    const { orgNodeMap, orgUserMap, jobUserMap, etcNode } = this.treeInfo

    const ret = []

    departments?.forEach((department) => {
      const { id, name, parent_id: parentId, members, position } = department

      const key = this.getDepartmentKey(id)
      if (orgNodeMap[id] == null) {
        const node = {
          key,
          title: name,
          children: [],
          type: 0, // 0: department, 1: user
          originData: department,
          isLeaf: false,
          position,
        }

        orgNodeMap[id] = node
      } else {
        // 중복되는 경우 또는 나중에 추가되는 경우.
        const existNode = orgNodeMap[id]
        existNode.key = key
        existNode.title = name
        existNode.originData = department
        existNode.position = position
      }

      const node = orgNodeMap[id]

      if (parentId == null) {
        ret.push(node)
      } else {
        let parentNode = orgNodeMap[parentId]
        if (parentNode == null) {
          const parentKey = this.getDepartmentKey(parentId)
          parentNode = {
            key: parentKey,
            type: 0,
            children: [],
            isLeaf: false,
          }
          orgNodeMap[parentId] = parentNode
        }
        parentNode.children.push(node)
      }

      members.forEach((member) => {
        const { user_id: userId, department_id: departmentId, position: memberPosition } = member

        const uniqueUserKey = this.getUniqueUserKey(userId, id)
        const userKey = this.getUserKey(userId)
        const user = this.userKeyMap[userKey]
        if (this.isJobView === true && jobUserMap[uniqueUserKey] == null) {
          const { jobposition_id: jobPositionId, jobtitle_id: jobTitleId } = member
          const jobPosition = jobpositions.find((job) => job.id === jobPositionId)
          const jobTitle = jobtitles.find((job) => job.id === jobTitleId)

          jobUserMap[uniqueUserKey] = {
            ...member,
            jobposition: jobPosition != null ? jobPosition.name : '',
            jobtitle: jobTitle != null ? jobTitle.name : '',
          }
        }

        let isValidUser = false

        if (user != null) {
          isValidUser = true
          const { account, display_name: displayName } = user.data
          const email = account != null ? account.toLowerCase() : ''
          const userName = displayName != null ? displayName.toLowerCase() : ''

          if (sText != null) {
            isValidUser =
              matchedDeptIdSet.has(id) || userName.indexOf(sText) >= 0 || email.indexOf(sText) >= 0
          }
        }

        if (isValidUser === true) {
          const userNode = {
            key: uniqueUserKey,
            type: 1, // 0: department, 1: user
            originData: user,
            isLeaf: true,
            position: memberPosition,
            disabled: this.isLicenseInactive(user), // KR 라이센스 미보유 → 선택 불가
          }

          filteredUniqueKeyMap[uniqueUserKey] = user

          if (orgUserMap[userId] == null) {
            orgUserMap[userId] = [userNode]
          } else {
            const existNode = orgUserMap[userId].find((item) => item.key === uniqueUserKey)
            if (existNode == null) {
              orgUserMap[userId].push(userNode)
            } else {
              existNode.originData = user
            }
          }

          if (orgNodeMap[departmentId] != null) {
            orgNodeMap[departmentId].children.push(userNode)
          } else {
            etcNode.children.push(userNode)
          }
        }
      })
    })

    filteredUsers.forEach((user) => {
      const { id } = user.data

      const uniqueUserKey = this.getUniqueUserKey(id, 'etc')
      const userNode = {
        key: uniqueUserKey,
        type: 1, // 0: department, 1: user
        originData: user,
        isLeaf: true,
        disabled: this.isLicenseInactive(user), // KR 라이센스 미보유 → 선택 불가
      }

      if (orgUserMap[id] == null || orgUserMap[id].length === 0) {
        orgUserMap[id] = [userNode]
        filteredUniqueKeyMap[uniqueUserKey] = user
        etcNode.children.push(userNode)
        etcNode.count += 1
      } else {
        const existNode = orgUserMap[id][0]
        if (existNode.originData == null) {
          existNode.originData = user
        }

        // const existNode = orgUserMap[id].find((node) => node.key === uniqueUserKey);
        // if (existNode == null) {
        //   orgUserMap[id].push(userNode);
        // } else {
        //   existNode.originData = user;
        // }
      }
    })

    const sortFunc = (a, b) => {
      const { position: aPosition, type: aType } = a
      const { position: bPosition, type: bType } = b
      if (aType === bType) {
        if (aPosition == null && bPosition == null) {
          const { name: aName, data: aData } = a.originData
          const { name: bName, data: bData } = b.originData
          const aText = aName || (aData != null ? aData.display_name : null)
          const bText = bName || (bData != null ? bData.display_name : null)
          return compareStr(aText, bText)
        }
        if (aPosition == null) {
          return -1
        }
        if (bPosition == null) {
          return 1
        }
        return aPosition - bPosition
      }
      return bType - aType
    }

    const countNode = (node) => {
      node.children = node.children.sort(sortFunc)
      const { children } = node
      let cnt = children.filter((child) => child.type === 1).length

      // loop를 돌면서 count가 0인 child를 제거해야 함.
      // 제거 시 index 문제를 피하기 위해 뒤에서부터 계산함.
      for (let i = children.length - 1; i >= 0; i -= 1) {
        const child = children[i]
        if (child.type === 0) {
          cnt += countNode(child)
        }

        if (child.count === 0) {
          children.splice(children.indexOf(child), 1)
        }
      }

      node.count = cnt
      return cnt
    }

    ret.forEach((node) => {
      countNode(node)
    })

    // countNode 는 자식만 제거하므로 최상위(루트) 부서는 결과가 0이어도 "(0)" 으로 남는다.
    // 검색 중일 때만 제거 — 비검색 시엔 빈 조직이어도 루트가 보여야 한다.
    let visibleNodes = ret
    if (sText != null) {
      visibleNodes = ret.filter((node) => node.count > 0)
    }

    if (etcNode.count > 0) {
      etcNode.etc = true
      etcNode.children = etcNode.children.sort(sortFunc)
      visibleNodes.push(etcNode)
    }

    // root 플래그(titleRender 의 새로고침 메뉴용)는 count 필터 "후" 첫 노드에 부여한다.
    // 필터 전 ret[0] 에 찍으면 검색으로 그 노드가 제거됐을 때 메뉴가 통째로 사라진다.
    if (visibleNodes.length > 0) {
      visibleNodes[0].root = true
    }

    this.treeData = visibleNodes

    return {
      treeData: visibleNodes,
      filteredUniqueKeyMap,
    }
  }

  setCheckedByKey = (uniqueKey, checked) => {
    const { orgUserMap } = this.treeInfo

    console.log(' --- setCheckedByKey --- ', uniqueKey, checked)

    const updatedCheckedKeys = [...this.checkedKeys]

    if (uniqueKey.indexOf('user_') === 0) {
      const id = this.getUserIdByKey(uniqueKey)
      orgUserMap[id].forEach(({ key }) => {
        if (checked === true && updatedCheckedKeys.indexOf(key) < 0) {
          updatedCheckedKeys.push(key)
        } else if (checked === false) {
          const idx = updatedCheckedKeys.indexOf(key)
          if (idx > -1) {
            updatedCheckedKeys.splice(idx, 1)
          }
        }
      })
    } else {
      const idx = updatedCheckedKeys.indexOf(uniqueKey)
      if (checked === true && idx < 0) {
        updatedCheckedKeys.push(uniqueKey)
      } else if (checked === false) {
        if (idx > -1) {
          updatedCheckedKeys.splice(idx, 1)
        }
      }
    }

    this.checkedKeys = Array.from(new Set(updatedCheckedKeys))

    this.setState({ checkedKeys: [...this.checkedKeys] })

    this.notifyChecked(this.checkedKeys)
  }

  titleRender = (node) => {
    const { t } = this.props
    const { isMobile1 } = this.state
    const { originData, type } = node
    let title = null
    if (type === 0) {
      const { count, root } = node
      if (root === true) {
        const menuAttrs = {
          items: [
            {
              label: t('common.button.refresh'),
              key: 'refresh',
            },
            // {
            //   label: t('editor.etc.close'),
            //   icon: <img src={menuSave16} alt="close" />,
            //   key: 'close',
            // },
          ],
          onClick: ({ key, domEvent }) => {
            this.onMenuClick('more', key)
            domEvent.stopPropagation()
          },
        }

        const dropdownAttrs = {
          overlayClassName: classNames('contextMenu'),
          menu: menuAttrs,
          trigger: ['click'],
          // onClick: (e) => {
          //   e.stopPropagation()
          // },
        }

        const moreBtn = (
          <Dropdown {...dropdownAttrs}>
            <Button type="text" icon={<img src={toolbarMore24} alt="more" />} />
          </Dropdown>
        )

        title = (
          <div className={classNames(styles.departmentItem)}>
            <span>
              {originData.name} ({count})
            </span>
            <span className={classNames('moreBtn')}>{moreBtn}</span>
          </div>
        )
      } else {
        title = (
          <div className={classNames(styles.departmentItem)}>
            <span>
              {originData.name} ({count})
            </span>
          </div>
        )
      }
    } else if (originData != null) {
      const {
        account,
        display_name: displayName,
        jobposition,
        profile_photo_url: profilePhotoUrl,
      } = originData.data

      let imgSrc = null
      if (
        profilePhotoUrl == null ||
        profilePhotoUrl.trim().length === 0 ||
        profilePhotoUrl.indexOf('my_default') > -1
      ) {
        imgSrc = getInitialAvatarSrc(displayName, account)
      } else {
        imgSrc = profilePhotoUrl
      }

      const { name: jobName } = jobposition || {}

      title = (
        <div className={classNames(styles.userItem)}>
          <img className={classNames(styles.avatar)} src={imgSrc} alt="avatar" />
          <div className={classNames(styles.info)}>
            <span className={classNames(styles.name)}>
              {displayName}
              {node.disabled === true && (
                <span className={classNames(styles.licenseInactive)}>
                  {' '}
                  {t('workspace.orgchart.licenseInactive')}
                </span>
              )}
            </span>
            {!isMobile1 && <span className={classNames(styles.email)}>{account}</span>}
          </div>
          <span className={classNames(styles.job)}>{jobName}</span>
        </div>
      )
    }

    return title
  }

  render() {
    const { treeInfo, loading, checkedKeys, expandedKeys, treeHeight } = this.state
    const { t } = this.props

    let userElems = null
    if (treeInfo != null) {
      const { treeData, filteredUniqueKeyMap } = treeInfo
      const filteredCheckedKeys = checkedKeys.filter((key) => {
        // const userKey = this.getUserKeyByUniqueKey(key);
        return filteredUniqueKeyMap[key] != null
      })

      const treeAttrs = {
        ref: this.treeRef,
        switcherIcon: (treeNodeProp) => {
          if (treeNodeProp.expanded === true) {
            return <img src={downIcon} alt="expand" />
          }
          return <img src={rightIcon} alt="fold" />
        },
        treeData,
        checkable: true,
        selectable: true,
        motion: 0,
        titleRender: this.titleRender,
        checkedKeys: filteredCheckedKeys,
        expandedKeys,
        height: treeHeight - 2,
        onSelect: (selectedKeys, e) => {
          if (
            e.nativeEvent.target.tagName.toLowerCase() === 'button' ||
            e.nativeEvent.target.closest('.moreBtn')
          ) {
            return null
          }

          const { node } = e
          const { key, type } = node

          if (type === 1) {
            // KR 라이센스 미보유(disabled) → 선택 차단(커스텀 체크 로직이라 antd 기본 제외에 의존 안 함)
            if (node.disabled === true) {
              return null
            }
            const pos = this.checkedKeys.indexOf(key)
            const checked = pos < 0
            this.setCheckedByKey(key, checked)
            this.onItemClick(node.originData)
          } else if (type === 0) {
            const pos = this.expandedKeys.indexOf(key)
            if (pos > -1) {
              this.expandedKeys.splice(pos, 1)
            } else {
              this.expandedKeys.push(key)
            }
            this.setState({ expandedKeys: [...this.expandedKeys] })
          }

          return selectedKeys
        },
        onExpand: (exKeys, { expanded, node }) => {
          console.log('exKeys - ', exKeys, expanded, node)

          this.expandedKeys = exKeys
          this.setState({ expandedKeys: [...this.expandedKeys] })
        },
        onCheck: (checkedKeys0, { checked, node }) => {
          console.log('onCheck - ', checkedKeys0, checked, node)
          // 부모(부서) 전체선택 시 disabled(라이센스 미보유) 자식 제외 — antd 기본 동작에 의존 안 함
          this.checkedKeys = checkedKeys0.filter((key) => {
            if (key.indexOf('user_') !== 0) return false
            const user = this.userKeyMap[this.getUserKeyByUniqueKey(key)]
            return !this.isLicenseInactive(user)
          })

          this.setCheckedByKey(node.key, checked)
        },
      }

      userElems = <Tree {...treeAttrs} />
    }

    const searchAttrs = {
      autoFocus: true,
      ref: this.searchRef,
      placeholder: t('workspace.search.placeholder'),
      onSearch: this.onSearch,
      prefix: <img src={search24SVG} alt="search" />,
      allowClear: { clearIcon: <img src={iconClear20SVG} alt="clear" /> },
      onChange: this.onChange,
    }

    return (
      <div className={classNames(styles.orgChartTree, 'orgChartTree')}>
        <Form component={false} ref={this.formRef}>
          <Form.Item name="val" noStyle>
            <Search {...searchAttrs} />
          </Form.Item>
        </Form>
        <Spin spinning={loading}>
          <div
            className={classNames(styles.tree)}
            ref={(ref) => {
              this.setRef(ref)
            }}
          >
            {userElems}
          </div>
        </Spin>
      </div>
    )
  }
}

const OrgChartUserList = withTranslation()(OrgChartUserListDef)

export default OrgChartUserList
